import { useEffect, useState } from "react";
import ServiceCard from "../../components/ServiceCard";
import CustomerService from "../../services/CustomerService";
import Lodder from "../../components/Lodder";
const SingleMemberLLC = () => {
    const [services,setServices]=useState([])
    const [showlodder,setShowlodder]=useState(false);
    
    useEffect(()=>{
      setShowlodder(true)
        CustomerService.GetCustomerServiceList()
        .then((response) => {
            if(response.status)
            {
               
              setServices(response.resultData.filter((element)=>{return element.serviceName==='Single Member LLC'}))
              /* response.resultData.forEach((element) => {
                if(element.serviceName==='Single Member LLC'){
                  setServices(element)
                }
              }); */
            }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(()=>{
          setShowlodder(false)
        });
        document.title="Foundry Law - Single Member LLC"
    },[])
  return (
    <>
    <Lodder show={showlodder}/>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            <div className="row mx-lg-3 mx-0">
              <div className="col-sm-6">
                <h1 className="m-0">SINGLE MEMBER LLC</h1>
              </div>
              {/* /.col */}
              {/* <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#" className="logout-font">
                    Legel Tools
                    </a>
                  </li>
                  <li className="breadcrumb-item active">Single Member LLC </li>
                </ol>
              </div> */}
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row  mx-lg-3 mx-0">
           {/*  <ServiceCard services={services}/> */}
           {services.map((item,index) => {
                return <ServiceCard key={index}services={item}/>;
              })}
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </>
  );
};
export default SingleMemberLLC;
